
import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, FormControl, Select, MenuItem, Box, List, ListItem, ListItemText, Checkbox, Button, ListSubheader } from '@mui/material';
import axios from '../../../utils/fvAxios';
import { ToastContainer, toast } from 'react-toastify';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export default function Configuration() {

    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: "320px",
            },

        },
    };
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };

    const [ClientList, setClientList] = useState([]);
    const [LocationsList, setLocationsList] = useState([]);
    const [courses, setCourses] = useState([]);


    const [ClientId, setClientId] = useState('');
    const [LocationId, setLocationId] = useState('');


    useEffect(() => {
        Details();
    }, []);

    const [spinner, setSpinner] = React.useState(false);
    const SpinnerClose = () => {
        setSpinner(false);
    };

    async function Details() {
        const res = await axios.get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false");
        setClientList(res?.data?.data);
    }

    async function ChangeClient(i) {
        setClientId(i);
        setCourses([]);
        const res = await axios.get("Companies/GetClientBusinessUnitSites?clientId=" + i);
        setLocationsList(res?.data?.data?.item3);
    };

    function LocationChange(i) {
        setLocationId(i);
        setSpinner(!spinner);
        axios.get("OnsiteOffsite/GetClientCourses?clientId=" + ClientId + "&LocationId=" + i)
            .then(res => {
                setCourses(res?.data?.data?.map((i) => ({
                    "courseid": i?.courseid,
                    "coursename": i?.coursename,
                    "clientcode": i?.clientcode,
                    "clientName": i?.clientName,
                    "coursefee": i?.coursefee,
                    "coursetype": i?.coursetype,
                    "locationid": i?.locationid,
                    "languageid": i?.languageid,
                    "clientId": i?.clientId,
                    "isMoodleCourse": i?.isMoodleCourse,
                    "isProRataRequired": i?.isProRataRequired,
                    "expiryMonth": i?.expiryMonth,
                    "visible": i?.visible,
                    "eligibleforrenewal": i?.eligibleforrenewal,
                    "isMandatory": i?.isMandatory == "True" ? true : false
                })));
            }).catch((error) => {
                console.log(error.res);
            }).finally(() => {
                setSpinner(false)
            });

    };

    const groupedData = LocationsList?.reduce((result, item) => {
        const clientName = item?.businessUnitName;

        if (!result[clientName]) {
            result[clientName] = [];
        }

        result[clientName].push(item);

        return result;
    }, {});

    // const groupedArray = Object.entries(groupedData)
    //     ?.map(([clientName, items]) => ({
    //         clientName,
    //         items: items.sort((a, b) => a.businessUnitName.localeCompare(b.businessUnitName)), // Sort items by coursename
    //     }))
    //     .sort((a, b) => a.businesUnitsiteName.localeCompare(b.businesUnitsiteName));

    const handleCheckboxChange = (courseId) => {
        setCourses(prevCourses =>
            prevCourses.map(course =>
                course.courseid === courseId
                    ? { ...course, isMandatory: !course.isMandatory } // Toggle isMandatory
                    : course
            )
        );
    };

    async function handleSave(e) {
        e.preventDefault();
        const cou = courses?.map((r) => {
            return {
                "courseId": r?.courseid,
                "isMandatory": r?.isMandatory
            }
        })
        const obj = {
            "locationId": LocationId,
            "mandatoryCourses": cou
        }
        setSpinner(!spinner);
        axios.post("TemplateTool/SaveLocationMandatoryTrainings", obj)
            .then(res => {
                if (res?.data?.responseCode == 100) {
                    toastNotify(res?.data?.responseMessage, true);
                } else {
                    toastNotify(res?.data?.responseMessage, false);
                }
            }).catch((error) => {
                console.log(error.res.data);
            }).finally(() => {
                setSpinner(false);
            });

    };
    return (
        <div>
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <FormControl variant="outlined" size="small" sx={{ marginLeft: "auto" }}>
                    <Select
                        sx={{
                            '& legend': { display: 'none' },
                            '& fieldset': { top: 0 },
                            width: "320px",
                            float: "right"
                        }}
                        //displayEmpty
                        //sx={{ minWidth: 180, float: "right" }}
                        labelId="demo-multiple-name-label"
                        value={ClientId || ""}
                        id="demo-multiple-name"
                        size="small"
                        onChange={(e) => ChangeClient(e.target.value)}
                        MenuProps={MenuProps}
                    >
                        {ClientList?.map((r, i) =>
                            <MenuItem key={i} title={r?.text} value={r?.value} > {r?.text}</MenuItem>
                        )}
                    </Select>
                </FormControl>

                <FormControl variant="outlined" size="small" >
                    {/* <Select
                        sx={{
                            '& legend': { display: 'none' },
                            '& fieldset': { top: 0 },
                            width: "320px",
                            float: "right"
                        }}
                        //displayEmpty
                        //sx={{ minWidth: 180, float: "right" }}
                        labelId="demo-multiple-name-label"
                        value={LocationId || ""}
                        id="demo-multiple-name"
                        size="small"
                        onChange={(e) => LocationChange(e.target.value)}
                        MenuProps={MenuProps}
                    >
                        {LocationsList?.map((r, i) =>
                            <MenuItem key={i} title={r?.key} value={r?.businessUnitSiteID} > {r?.businesUnitsiteName}</MenuItem>
                        )}
                    </Select> */}
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={LocationId || ""}
                        label="Client Name"
                        //onChange={LocationChange}
                        onChange={(e) => LocationChange(e.target.value)}
                        displayEmpty
                        sx={{
                            width: "320px",
                            '& legend': { display: 'none' },
                            '& fieldset': { top: 0 },
                            fontFamily: 'Arial, FontAwesome',
                        }}
                        MenuProps={{
                            PaperProps: MenuProps.PaperProps,
                        }}
                    >

                        {Object?.entries(groupedData)?.map(([group, groups]) => [
                            <ListSubheader key={group} sx={{ lineHeight: "22px", color: "#fff", backgroundColor: "#b9b3b3" }} title={group}>
                                <div style={{ width: "300px" }}>
                                    <span style={{}}>{group}</span></div>
                            </ListSubheader>,
                            ...groups?.map((item) => (
                                <MenuItem key={item?.businessUnitSiteID} value={item?.businessUnitSiteID} title={item?.businesUnitsiteName} >
                                    <div style={{ width: "300px", textOverflow: "ellipsis", overflowX: "hidden", }}>
                                        {item?.businesUnitsiteName}
                                    </div>
                                </MenuItem>
                            )),
                            group < groupedData?.length - 1,
                        ])}
                    </Select>

                </FormControl>
            </Box>


            {courses?.length < 1 ?
                <div hidden={spinner}>
                    <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 4, width: "auto" }} className="text-center">
                        <span style={{ color: "#667085" }}>No Result Found</span>
                    </Box>
                </div> : <>
                    <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" style={{ padding: 16, marginTop: 4, width: "auto" }}>
                        <Typography variant="h6" sx={{ flexGrow: 1, marginLeft: 1 }}>
                            Configure mandatory training(s) for the selected location
                        </Typography>
                        <List>
                            {courses?.map((item) => (
                                <ListItem key={item.courseid} sx={{cursor:"pointer"}} dense onClick={() => handleCheckboxChange(item?.courseid)}>
                                    <Checkbox
                                        edge="start"
                                        id={item?.courseid}
                                        checked={item?.isMandatory}
                                        //onChange={() => handleCheckboxChange(item?.courseid)}
                                    />
                                    <ListItemText primary={item?.coursename} />
                                </ListItem>
                            ))}
                        </List>

                        <Button hidden={courses?.length < 1} variant="contained" color="primary" className='p-3 mx-2' onClick={handleSave}>
                            Save
                        </Button>

                    </Box>
                </>}
        </div>
    );
}
